import { ReactComponent as ClockIcon } from 'images/newIcons/clock.svg';
import { ReactComponent as FolderIcon } from 'images/newIcons/folder.svg';
import { ReactComponent as FolderPrivateClosedIcon } from 'images/newIcons/folderPrivateClosed.svg';
import { ReactComponent as FolderPrivateOpenedIcon } from 'images/newIcons/folderPrivateOpened.svg';
import { ISelectOption } from 'interfaces';

import { TreeSelectOptionNode, TreeSelectOptionNodeData } from './types';

export const getOptionTreeData = <T, P>({
  value,
  options,
  parent = '0',
  level = 0,
  empty,
}: {
  value: T;
  options: ISelectOption<T, P>[];
  parent?: string;
  level?: number;
  empty?: boolean;
}): TreeSelectOptionNodeData<T, P>[] => {
  const emptyOption = {
    id: '-1',
    name: 'Не выбрано',
    type: 'object',
    isFolder: false,
    entity: { label: 'Не выбрано', value: null },
    info: {
      level: 0,
      parent: '0',
    },
    state: {
      selected: !value,
    },
  } as TreeSelectOptionNodeData<T, P>;

  return [
    ...(empty ? [emptyOption] : []),
    ...options.reduce((acc, curr) => {
      const id = String(curr.id ?? curr.value);
      const isFolder = 'children' in curr;

      const optionNode = {
        id: id,
        name: curr.label,
        type: isFolder ? 'folder' : 'object',
        isFolder: isFolder,
        entity: {
          label: curr.label,
          value: curr.value,
          isFavourite: curr.isFavorite,
          isRecent: curr.isRecent,
          properties: curr.properties,
          isPersonalSpace: curr.isPersonalSpace,
        },
        info: {
          level: level,
          parent: parent,
        },
        state: {
          selected: value === curr.value,
        },
        ...(isFolder && {
          children: getOptionTreeData({
            value,
            options: curr.children ?? [],
            parent: id,
            level: level + 1,
          }),
        }),
      } as TreeSelectOptionNodeData<T, P>;

      return [...acc, optionNode];
    }, [] as TreeSelectOptionNodeData<T, P>[]),
  ];
};

export const searchMatch = <T, P>(
  node: TreeSelectOptionNode<T, P>,
  term: string
) => node.data.name.toLocaleLowerCase().includes(term.toLocaleLowerCase());

export const renderNodeIcon = <T, P>({
  data,
  isOpen,
}: TreeSelectOptionNode<T, P>) => {
  const {
    isFolder,
    entity: { isPersonalSpace, isRecent },
  } = data;

  if (!isFolder) return null;
  if (isRecent) return <ClockIcon className="w-full h-full" />;
  if (isPersonalSpace)
    return isOpen ? <FolderPrivateOpenedIcon /> : <FolderPrivateClosedIcon />;

  return <FolderIcon className="w-full h-full" />;
};
